import React from 'react';
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";
import Carousel from './layouts/Carousel';
import Grid from './layouts/Grid';

import './SpecialisedServices.scss';

const layouts = {
  'grid': Grid,
  'carousel': Carousel,
}
export const SpecialisedServices = ({ settings, blocks }) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const layout = isMobile ?settings?.section.layout_mobile : settings?.section.layout;
  
  const LayoutComponent = layouts[layout] || Grid;
  return (
    <LayoutComponent settings={settings} blocks={blocks}/>
  );
};

export default SpecialisedServices;

